import React from 'react';
import HeroSection from '@/components/sections/automation/HeroSection';
import BenefitsSection from '@/components/sections/automation/BenefitsSection';
import UseCasesSection from '@/components/sections/automation/UseCasesSection';
import ROICalculator from '@/components/sections/automation/ROICalculator';
import ProcessSection from '@/components/sections/automation/ProcessSection';
import ContactForm from '@/components/sections/automation/ContactForm';
import CTASection from '@/components/sections/automation/CTASection';
import SEO from '@/components/SEO';
import BookingModule from '@/components/sections/BookingModule';
import EstimationForm from '@/components/sections/EstimationForm';
import FAQ from '@/components/ui/FAQ';

const AutomationDevelopment = () => {
  const faqItems = [
    {
      question: "Quels types de processus peuvent être automatisés ?",
      answer: "Nous automatisons une large gamme de processus : traitement de données, workflows métier, génération de rapports, intégration entre systèmes, tâches administratives répétitives, et processus de validation. Notre expertise s'étend de l'automatisation simple à l'intelligence artificielle avancée."
    },
    {
      question: "Comment identifiez-vous les processus à automatiser ?",
      answer: "Nous commençons par un audit complet de vos processus actuels, identifiant les tâches répétitives, chronophages ou sujettes aux erreurs. Nous évaluons ensuite le ROI potentiel et proposons une feuille de route d'automatisation priorisée."
    },
    {
      question: "Quelles technologies utilisez-vous pour l'automatisation ?",
      answer: "Nous utilisons diverses technologies selon les besoins : RPA (UiPath, Automation Anywhere), scripts Python pour l'automatisation, APIs REST, webhooks, workflow engines, et outils d'IA/ML pour l'automatisation intelligente. Nous privilégions les solutions robustes et maintenables."
    },
    {
      question: "Comment assurez-vous la fiabilité des automatisations ?",
      answer: "Nous implémentons des systèmes de monitoring, logs détaillés, alertes en cas d'erreur, et mécanismes de reprise. Chaque automatisation est testée rigoureusement et inclut des mécanismes de fallback pour gérer les cas exceptionnels."
    },
    {
      question: "Peut-on intégrer l'automatisation avec nos systèmes existants ?",
      answer: "Oui, nous concevons des solutions qui s'intègrent parfaitement avec vos systèmes existants (ERP, CRM, etc.) via des APIs, connecteurs standards, ou intégrations personnalisées. Nous assurons une transition fluide sans perturber vos opérations."
    },
    {
      question: "Comment mesurez-vous le succès de l'automatisation ?",
      answer: "Nous définissons des KPIs clairs : temps gagné, réduction des erreurs, ROI, satisfaction utilisateur. Nous fournissons des tableaux de bord pour suivre ces métriques et optimisons continuellement les processus automatisés."
    }
  ];

  return (
    <>
      <SEO 
        title="Automatisation des Processus | Solutions RPA Intelligentes"
        description="Optimisez vos processus métier avec nos solutions d'automatisation intelligente. Réduisez les tâches manuelles, améliorez l'efficacité et accélérez votre transformation digitale. Expertise en RPA, IA et intégration de systèmes."
        keywords="automatisation, RPA, workflow, processus métier, transformation digitale, efficacité opérationnelle, intelligence artificielle, intégration systèmes, optimisation processus, automatisation intelligente"
        type="service"
        url="https://innov.orcsys.fr/ia-automatisation"
        image="https://innov.orcsys.fr/images/automation-development-preview.jpg"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <BenefitsSection />
        <UseCasesSection />
        <ROICalculator />
        <ProcessSection />
        <EstimationForm />
        <CTASection />
        <BookingModule projectType="automation" />
        <FAQ 
          title="Questions Fréquentes sur l'Automatisation"
          subtitle="Découvrez comment nous pouvons automatiser et optimiser vos processus"
          items={faqItems}
          className="bg-slate-50"
        />
      </div>
    </>
  );
};

export default AutomationDevelopment; 